import { Spinner } from "react-bootstrap";

export const Loader = () => (
    <div className="mx-auto mt-5 text-center">
        <Spinner  animation="border" />
    </div>
);